"use strict";var log=console.log;window.console||(console={},console.log=function(){},log=function log(){});